(() => {
  const init = () => document.querySelectorAll('[data-ck-glitter-switch]').forEach(switcher => {
    if (switcher.dataset.displayReady) return;
    switcher.dataset.displayReady = 'true';
    const root = switcher.closest('[data-product-root]');
    if (!root) return;
    const heading = root.querySelector('.casekoo-product-title');
    if (heading) heading.textContent = switcher.dataset.glitterTitle;
    const update = event => {
      const {product, variant} = event.detail || {};
      if (!product || !variant || event.detail.productRootEl !== root) return;
      const isGlitter = String(product.id) === switcher.dataset.haloProductId;
      if (heading) heading.textContent = isGlitter ? switcher.dataset.glitterTitle : switcher.dataset.clearTitle;
      switcher.querySelector('[data-ck-glitter-note]').hidden = isGlitter;
      const link = switcher.querySelector('[data-ck-halo-detail-link]');
      if (!isGlitter && link) link.href = switcher.dataset.frostUrl + '?variant=' + variant.id;
    };
    document.addEventListener('theme:variant:change', update);
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
